import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DiscountFeatureService from "service/DiscountFeatureService";

export const getDiscounts = createAsyncThunk("getDiscounts", async (shopDomain) => {
  const response = await DiscountFeatureService.getAllDiscounts(shopDomain);
  return response.data;
});

export const discountSlice = createSlice({
  name: "discounts",
  initialState: {
    list: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDiscounts.fulfilled, (state, action) => {
      state.list = action.payload.data;
    });
  },
});

export const {} = discountSlice.actions;

export default discountSlice.reducer;
